import React from "react"
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  CircularProgress,
} from "@mui/material"
import { useDeleteExpense } from "../hooks/useOrganizationExpenses"
import { useAuthContext } from "context/auth/authContext"
import PropTypes from "prop-types"
import i18n from "i18n"

const DeleteModal = ({ open, onClose, costData }) => {
  const { user } = useAuthContext()
  const organizationId = user && user["custom:organizationId"]
  const deleteExpenseMutation = useDeleteExpense()

  const handleConfirm = () => {
    if (!costData || !organizationId) return
    deleteExpenseMutation.mutate({
      organizationId,
      expenseId: costData.expenseId,
    })
  }

  React.useEffect(() => {
    if (deleteExpenseMutation.isSuccess) {
      onClose()
      deleteExpenseMutation.reset()
    }
  }, [deleteExpenseMutation.isSuccess, onClose, deleteExpenseMutation])

  return (
    <Dialog open={open} onClose={onClose} data-testid="delete-modal">
      <DialogTitle>{i18n.t("costs.delete.title")}</DialogTitle>
      <DialogContent>
        <DialogContentText>{i18n.t("costs.delete.message")}</DialogContentText>
      </DialogContent>

      <DialogActions sx={{ p: 2 }}>
        <Button
          onClick={onClose}
          color="secondary"
          disabled={deleteExpenseMutation.isLoading}
        >
          {i18n.t("common.cancel")}
        </Button>
        <Button
          onClick={handleConfirm}
          variant="contained"
          color="error"
          data-testid="confirm-delete-button"
          disabled={deleteExpenseMutation.isLoading}
        >
          {deleteExpenseMutation.isLoading ? (
            <CircularProgress size={24} color="inherit" />
          ) : (
            i18n.t("costs.delete.confirm")
          )}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

DeleteModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  costData: PropTypes.object,
}

export default DeleteModal
